import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthCheck } from "../components/Auth";
import { api } from "../components/Api";
import Loading from "../components/Loading";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";

export default function TypeList() {
    const [types, setTypes] = useState([]);
    const [loading, setLoading] = useState(true);
    const { checkToken } = useAuthCheck();
    const navigate = useNavigate();

    useEffect(() => { checkToken(); }, [checkToken]);

    useEffect(() => {
        fetchTypes();
    }, []);

    const fetchTypes = async () => {
        setLoading(true);
        try {
            const res = await api.get("/types");
            setTypes(res.data);
        } catch (err) {
            console.error(err);
            alert("Erreur lors de la récupération des types.");
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (typeId) => {
        try {
            // Vérifier si le type est utilisé dans un produit
            const res = await api.get(`/products?type_id=${typeId}`);
            if (res.data.data.length > 0) {
                alert("Impossible de supprimer ce type car il est utilisé dans un produit.");
                return;
            }

            if (!window.confirm("Voulez-vous vraiment supprimer ce type ?")) return;

            await api.delete(`/types/${typeId}`);
            alert("Type supprimé !");
            fetchTypes();
        } catch (err) {
            console.error(err);
            alert("Erreur lors de la suppression du type.");
        }
    };

    const token = localStorage.getItem("token");

    if (!token || localStorage.getItem("role") > 2) {
        navigate("/");
    }

    return (
        <div className="container mx-auto p-6">
            <h1 className="text-2xl font-bold mb-6 dark:text-white">Liste des Types</h1>

            <button
                onClick={() => navigate("/add-type")}
                className="bg-blue-400 hover:bg-blue-500 text-white font-semibold rounded px-4 py-2 mb-4"
            >
                Ajouter un type
            </button>

            {loading ? (
                <Loading message="Chargement des types..." />
            ) : (
                <table className="w-full border-collapse border text-sm text-center">
                    <thead className="bg-gray-100 dark:bg-gray-800">
                        <tr>
                            <th className="border px-2 py-1">Nom</th>
                            <th className="border px-2 py-1">Référence</th>
                            <th className="border px-2 py-1">Supprimer</th>
                        </tr>
                    </thead>
                    <tbody>
                        {types.map((type, index) => {
                            const bgColor = index % 2 === 0 ? "dark:bg-gray-600 bg-gray-050" : "dark:bg-gray-700 bg-gray-100";
                            return (
                                <tr key={type.id} className={`${bgColor}`}>
                                    <td className="border px-2 py-1">{type.type_name}</td>
                                    <td className="border px-2 py-1">{type.type_ref}</td>
                                    <td className="border px-2 py-1">
                                        <button
                                            onClick={() => handleDelete(type.id)}
                                            className="text-red-500 text-2xl"
                                        >
                                            <FontAwesomeIcon icon={faTrashCan} />
                                        </button>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            )}
        </div>
    );
}
